<template lang="pug">
  .popup-content-wrapper
    .popup-header {{$t('MOBILE_POPUP_ATTENTION_TITLE')}}
    .popup-content
      .description {{$t('MOBILE_POPUP_ATTENTION_DESCRIPTION')}}
    .popup-actions
      kraus-button(:label="$t('MOBILE_POPUP_ATTENTION_LINK_TEXT')",
        :colors="{label: '#FFFFFF', background: '#0558AB'}",
        :border="true",
        @click="onGotoClick")
</template>
<script>
import KrausButton from '@/components/_common/ui/KrausButton';
export default {
  name: 'MobileDevice',
  components: { KrausButton },
  data() {
    return {}
  },

  methods: {
    onGotoClick() {
      window.location = window.location.origin //'https://kraust.ru/'
    },
  }
}
</script>
